var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"num-wrap"},_vm._l((_vm.numList),function(item){return _c('img',{attrs:{"src":_vm.getImg(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }